export default __webpack_public_path__ + "cdbefc70e47da9e643077c0bfbbc965d.png";